import React from 'react';

import { navigate } from '../actions/route';
import { CALCULATOR } from '../stores/route';

export default (props) => (
  <div className="view drinks empty">
    <header>
      <h1>Drinks</h1>
    </header>
    <p>You haven't tracked any drinks.</p>
    <p>
      <button
        className="btn"
        onClick={() => navigate(CALCULATOR)}>Add one</button>
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/drinks-empty.js